/**
 * Locales where analytics must wait for the visitor's explicit consent.
 * Add a locale here if its cookie rules require the same treatment.
 */
export const ADVANCED_CONSENT_LOCALES = ['en-gb'] as const;
